import axios from 'axios'

export const comprehendClient = axios.create({
  baseURL: import.meta.env.VITE_COMPREHEND_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
})
